
import {

    CORE_GET_STATION_LIST_REQUEST,
    CORE_GET_STATION_LIST_SUCCESS,
    CORE_GET_STATION_LIST_FAILURE,

    CORE_GET_DEVICE_LIST_REQUEST,
    CORE_GET_DEVICE_LIST_SUCCESS,
    CORE_GET_DEVICE_LIST_FAILURE,

    CORE_GET_DEVICE_KPI_REQUEST,
    CORE_GET_DEVICE_KPI_SUCCESS,
    CORE_GET_DEVICE_KPI_FAILURE,

    CORE_GET_DEVICE_KPI_DAY_REQUEST,
    CORE_GET_DEVICE_KPI_DAY_SUCCESS,
    CORE_GET_DEVICE_KPI_DAY_FAILURE,

    CORE_GET_DEVICE_KPI_MONTH_REQUEST,
    CORE_GET_DEVICE_KPI_MONTH_SUCCESS,
    CORE_GET_DEVICE_KPI_MONTH_FAILURE,

    CORE_GET_DEVICE_KPI_YEAR_REQUEST,
    CORE_GET_DEVICE_KPI_YEAR_SUCCESS,
    CORE_GET_DEVICE_KPI_YEAR_FAILURE,

    CORE_GET_DEVICE_FIVE_MINUTES_REQUEST,
    CORE_GET_DEVICE_FIVE_MINUTES_SUCCESS,
    CORE_GET_DEVICE_FIVE_MINUTES_FAILURE,

    CORE_GET_KPI_STATION_HOUR_REQUEST,
    CORE_GET_KPI_STATION_HOUR_SUCCESS,
    CORE_GET_KPI_STATION_HOUR_FAILURE,

    CORE_GET_KPI_STATION_DAY_REQUEST,
    CORE_GET_KPI_STATION_DAY_SUCCESS,
    CORE_GET_KPI_STATION_DAY_FAILURE,

    CORE_GET_KPI_STATION_MONTH_REQUEST,
    CORE_GET_KPI_STATION_MONTH_SUCCESS,
    CORE_GET_KPI_STATION_MONTH_FAILURE,

    CORE_GET_KPI_STATION_YEAR_REQUEST,
    CORE_GET_KPI_STATION_YEAR_SUCCESS,
    CORE_GET_KPI_STATION_YEAR_FAILURE,
    CORE_GET_STATION_REAL_KPI_REQUEST,
    CORE_GET_STATION_REAL_KPI_SUCCESS,
    CORE_GET_STATION_REAL_KPI_FAILURE,

    CORE_GET_STATION_REAL_KPI_HOMESITE_REQUEST,
    CORE_GET_STATION_REAL_KPI_HOMESITE_SUCCESS,
    CORE_GET_STATION_REAL_KPI_HOMESITE_FAILURE,

} from '../types'
import { REQUEST_STATE } from '../types';
const requestState = REQUEST_STATE;

export default {

    serviceStationList: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_STATION_LIST_REQUEST:
                return state;
            case CORE_GET_STATION_LIST_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_GET_STATION_LIST_FAILURE:
                return [];
            default:
                return state;
        }
    },

    serviceDeviceList: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_DEVICE_LIST_REQUEST:
                return state;
            case CORE_GET_DEVICE_LIST_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                } case CORE_GET_DEVICE_LIST_FAILURE:
                return [];
            default:
                return state;
        }
    },
    serviceStationRealKpi: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_STATION_REAL_KPI_REQUEST:
                return state;
            case CORE_GET_STATION_REAL_KPI_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                } case CORE_GET_STATION_REAL_KPI_FAILURE:
                return [];
            default:
                return state;
        }
    },
    serviceStationRealKpiForHomeSite: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_STATION_REAL_KPI_HOMESITE_REQUEST:
                return state;
            case CORE_GET_STATION_REAL_KPI_HOMESITE_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                } case CORE_GET_STATION_REAL_KPI_HOMESITE_FAILURE:
                return [];
            default:
                return state;
        }
    },


    serviceDeviceKpi: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_DEVICE_KPI_REQUEST:
                return state;
            case CORE_GET_DEVICE_KPI_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_GET_DEVICE_KPI_FAILURE:
                return [];
            default:
                return state;
        }
    },
    serviceDeviceKpiDay: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_DEVICE_KPI_DAY_REQUEST:
                return state;
            case CORE_GET_DEVICE_KPI_DAY_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_GET_DEVICE_KPI_DAY_FAILURE:
                return [];
            default:
                return state;
        }
    },
    serviceDeviceKpiMonth: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_DEVICE_KPI_MONTH_REQUEST:
                return state;
            case CORE_GET_DEVICE_KPI_MONTH_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_GET_DEVICE_KPI_MONTH_FAILURE:
                return [];
            default:
                return state;
        }
    },
    serviceDeviceKpiYear: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_DEVICE_KPI_YEAR_REQUEST:
                return state;
            case CORE_GET_DEVICE_KPI_YEAR_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_GET_DEVICE_KPI_YEAR_FAILURE:
                return [];
            default:
                return state;
        }
    },
    deviceFiveMinutesData: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_DEVICE_FIVE_MINUTES_REQUEST:
                return state;
            case CORE_GET_DEVICE_FIVE_MINUTES_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_GET_DEVICE_FIVE_MINUTES_FAILURE:
                return [];
            default:
                return state;
        }
    },
    kpiStationHourData: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_KPI_STATION_HOUR_REQUEST:
                return state;
            case CORE_GET_KPI_STATION_HOUR_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_GET_KPI_STATION_HOUR_FAILURE:
                return [];
            default:
                return state;
        }
    },
    kpiStationDayData: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_KPI_STATION_DAY_REQUEST:
                return state;
            case CORE_GET_KPI_STATION_DAY_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_GET_KPI_STATION_DAY_FAILURE:
                return [];
            default:
                return state;
        }
    },
    kpiStationMonthData: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_KPI_STATION_MONTH_REQUEST:
                return state;
            case CORE_GET_KPI_STATION_MONTH_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_GET_KPI_STATION_MONTH_FAILURE:
                return [];
            default:
                return state;
        }
    },
    kpiStationYearData: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_KPI_STATION_YEAR_REQUEST:
                return state;
            case CORE_GET_KPI_STATION_YEAR_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_GET_KPI_STATION_YEAR_FAILURE:
                return [];
            default:
                return state;
        }
    },
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/reducerServiceAPI.js